import React, {useState} from "react"
import {useSolution, useLocal} from "../../AppContext"
import {MenuListOption} from "../../Components/MenuListOption"
import {Apply} from "./Apply"

const TYPE_HIDE = 1
const TYPE_REMOVE = 2
const TYPE_REMOVE_TYPE = 3
const TYPE_REMOVE_ALL = 4

export const ItemRemove = () => {
    const local = useLocal()
    const solution = useSolution()
    const [state, setState] = useState(TYPE_HIDE)
    const isHide = state === TYPE_HIDE
    const isRemove = state === TYPE_REMOVE
    const isRemoveType = state === TYPE_REMOVE_TYPE
    const isRemoveAll = state === TYPE_REMOVE_ALL

    const onHide = () => {
        setState(TYPE_HIDE)
    }

    const onRemove = () => {
        setState(TYPE_REMOVE)
    }

    const onRemoveType = () => {
        setState(TYPE_REMOVE_TYPE)
    }

    const onRemoveAll = () => {
        setState(TYPE_REMOVE_ALL)
    }

    const onApply = () => {
        if (isHide) solution.itemHideElement()
        else if (isRemove) solution.itemRemove()
        else if (isRemoveType) solution.itemRemoveType()
        else if (isRemoveAll) solution.itemRemoveAll()
    }

    return <>
        <div>
            <MenuListOption
                label={local.__("Nur diesen Absorber")}
                description={local.__("Bei dieser Auswahl wird nur der grün markierte Absorber aus Ihrer Raumansicht entfernt.")}
                isActive={isHide}
                onClick={onHide}
            />
            <MenuListOption
                label={local.__("Gesamte Packeinheit entfernen")}
                description={local.__("Hier werden die orange markierten Absorber (gesamte Packeinheit) aus Ihrer Planung entfernt.")}
                isActive={isRemove}
                onClick={onRemove}
            />
            <MenuListOption
                label={local.__("Alle Absorber diesen Typs entfernen")}
                description={local.__("Mit dieser Auswahl entfernen Sie alle Absorber im gleichen Stil, unabhängig von der jeweiligen Packeinheit.")}
                isActive={isRemoveType}
                onClick={onRemoveType}
            />
            <MenuListOption
                label={local.__("All Absorber im Raum entfernen")}
                description={local.__("Mit dieser Auswahl entfernen Sie alle Absorber im Raum und Sie können einen Alternativvorschlag ausprobieren.")}
                isActive={isRemoveAll}
                onClick={onRemoveAll}
            />
        </div>
        <Apply onClick={onApply}/>
    </>
}

